export const ChatFormatType = Object.freeze({
    STRING: 'string',
    TABLE: 'table',
    LIST: 'list',
    CUSTOM: 'custom',
    MULTIPLE: 'multiple',
    HTML: 'html',
    CHART: 'chart',
});
